export enum CardStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled',
  PENDING = 'pending',
}

export enum CardType {
  VIRTUAL = 'virtual',
  PHYSICAL = 'physical',
}

export enum ConnectedAccountStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  DELETED = 'deleted',
  PENDING_VERIFICATION = 'pendingVerification',
}

export enum ConnectedStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export const ActivateAccountCalled = 'activateAccountCalled';
